import ScreenHeader from '../components/ScreenHeader.js';

export default function Help() {
    return (
        <div className="app-wide__container">
            <ScreenHeader message="Help" />
            <div className="app-wide__main" style={{ padding: '24px 16px', textAlign: 'center' }}>
                <p>Help coming soon.</p>
            </div>
        </div>
    );
}
